import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "popUpWindow register" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "c-p-3 shadow" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "registerSteps" }, [
    /*#__PURE__*/_createElementVNode("li", { class: "selected" }, [
      /*#__PURE__*/_createElementVNode("small", { class: "line" }),
      /*#__PURE__*/_createElementVNode("span", null, "1")
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("span", null, "2")
    ])
  ])
], -1)
const _hoisted_3 = { class: "c-p-3" }
const _hoisted_4 = { class: "stepHeader" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("hr", { class: "primaryShort" }, null, -1)
const _hoisted_6 = { for: "firstname" }
const _hoisted_7 = { for: "lastname" }
const _hoisted_8 = { for: "email" }
const _hoisted_9 = { for: "phone_number" }
const _hoisted_10 = { for: "password" }
const _hoisted_11 = { for: "repeatepassword" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "wrapperConsent" }
const _hoisted_14 = { href: '/terms-and-conditions' }
const _hoisted_15 = { href: '/terms-and-conditions' }
const _hoisted_16 = { class: "registerDescription" }
const _hoisted_17 = { class: "wrapperConsent" }
const _hoisted_18 = {
  key: 1,
  style: {"color":"red","font-size":"12px","margin-top":"30px"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", { class: "grayWide margin-30" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "icon-warpit_icon_arrow-R" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Password = _resolveComponent("Password")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t("register.title")), 1)
      ]),
      _hoisted_5,
      _createElementVNode("span", {
        class: _normalizeClass(["p-float-label", { 'error-label': _ctx.errors.first_name }])
      }, [
        _createVNode(_component_InputText, {
          id: "firstname",
          type: "text",
          modelValue: _ctx.form.first_name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.first_name) = $event)),
          name: "firstname",
          maxlength: "80"
        }, null, 8, ["modelValue"]),
        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("register.first_name")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.errors.first_name), 1)
      ], 2),
      _createElementVNode("span", {
        class: _normalizeClass(["p-float-label", { 'error-label': _ctx.errors.last_name }])
      }, [
        _createVNode(_component_InputText, {
          id: "lastname",
          type: "text",
          modelValue: _ctx.form.last_name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.last_name) = $event)),
          name: "lastname",
          maxlength: "100"
        }, null, 8, ["modelValue"]),
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t("register.last_name")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.errors.last_name), 1)
      ], 2),
      _createElementVNode("span", {
        class: _normalizeClass(["p-float-label", { 'error-label': _ctx.errors.email }])
      }, [
        _createVNode(_component_InputText, {
          id: "email",
          type: "text",
          modelValue: _ctx.form.email,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email) = $event)),
          name: "email",
          maxlength: "35"
        }, null, 8, ["modelValue"]),
        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("register.email")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.errors.email), 1)
      ], 2),
      _createElementVNode("span", {
        class: _normalizeClass(["p-float-label", { 'error-label': _ctx.errors.phone_number }])
      }, [
        _createVNode(_component_InputText, {
          id: "phone_number",
          type: "text",
          modelValue: _ctx.form.phone_number,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.phone_number) = $event)),
          name: "phone_number",
          maxlength: "35"
        }, null, 8, ["modelValue"]),
        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t("register.phoneNumber")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.errors.phone_number), 1)
      ], 2),
      _createElementVNode("span", {
        class: _normalizeClass(["p-float-label", { 'error-label': _ctx.errors.password }])
      }, [
        _createVNode(_component_Password, {
          id: "password",
          "toggle-mask": true,
          modelValue: _ctx.form.password,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.password) = $event)),
          name: "password",
          maxlength: "100",
          "medium-regex": _ctx.mediumPattern.source,
          "strong-regex": _ctx.strongPattern.source
        }, null, 8, ["modelValue", "medium-regex", "strong-regex"]),
        _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("register.password")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.errors.password), 1)
      ], 2),
      _createElementVNode("span", {
        class: _normalizeClass(["p-float-label margin-0", { 'error-label': _ctx.errors.password_confirmation }])
      }, [
        _createVNode(_component_Password, {
          id: "repeatepassword",
          "toggle-mask": true,
          modelValue: _ctx.form.password_confirmation,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.password_confirmation) = $event)),
          name: "repeatepassword",
          maxlength: "100"
        }, null, 8, ["modelValue"]),
        _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("register.confirm_password")), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.errors.password_confirmation), 1)
      ], 2),
      (Object.keys(_ctx.errors).length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.responseErrors, (error) => {
              return (_openBlock(), _createElementBlock("p", {
                key: error,
                style: {"color":"red","font-size":"12px","margin-top":"30px"}
              }, _toDisplayString(error), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_InputSwitch, {
          modelValue: _ctx.consents.terms,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.consents.terms) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("label", null, [
          _createElementVNode("strong", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("register.agree")) + " ", 1),
            _createElementVNode("a", _hoisted_14, _toDisplayString(_ctx.$t("register.general_terms")), 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("register.and")) + " ", 1),
            _createElementVNode("a", _hoisted_15, _toDisplayString(_ctx.$t("register.privacy_policy")), 1)
          ]),
          _createElementVNode("small", _hoisted_16, _toDisplayString(_ctx.$t("register.description")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_InputSwitch, {
          modelValue: _ctx.consents.age,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.consents.age) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("label", null, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("register.older_than_fifteen")), 1)
        ])
      ]),
      (_ctx.errors.consents === true)
        ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(_ctx.$t("register.read_consents")), 1))
        : _createCommentVNode("", true),
      _hoisted_19,
      _createElementVNode("button", {
        class: "defaultButton next",
        onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t("register.goToVerification")) + " ", 1),
        _hoisted_20
      ]),
      _createElementVNode("a", {
        href: "#",
        class: "cancel",
        onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.backToHomePage && _ctx.backToHomePage(...args)), ["prevent"]))
      }, _toDisplayString(_ctx.$t("global.back")), 1)
    ])
  ]))
}